import React from 'react';
import ArtPiece from './ArtPiece';
import ContactButton from '../common/ContactButton';

const ArtGallery = ({ artData, onContactClick }) => {
    return (
        <div className="py-20">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h1 className="text-4xl font-light text-gray-900 mb-4">
                        {artData?.title || 'Art Commissions'}
                    </h1>
                    <p className="text-xl text-gray-600 mb-8">
                        Bringing your vision to life through custom artwork and commissioned pieces.
                    </p>
                    <ContactButton
                        text="Inquire About Pricing"
                        inquiryType="Art Commission"
                        prefilledData={{
                            message: "I'm interested in commissioning a custom artwork. Please let me know about your process and pricing.",
                            serviceDetails: "Art commission inquiry"
                        }}
                        onClick={onContactClick}
                        className="mx-auto"
                    />
                </div>

                <div className="space-y-12">
                    {artData?.pieces?.map((piece) => (
                        <ArtPiece
                            key={piece.id}
                            piece={piece}
                            onContactClick={onContactClick}
                        />
                    ))}
                </div>

                {(!artData?.pieces || artData.pieces.length === 0) && (
                    <div className="text-center py-20">
                        <p className="text-gray-500 text-lg">Art pieces coming soon...</p>
                    </div>
                )}

                <div className="text-center mt-16">
                    <ContactButton
                        text="Commission Your Artwork"
                        inquiryType="Art Commission"
                        prefilledData={{
                            message: "I would like to discuss commissioning a custom piece. Please contact me to discuss my vision and requirements.",
                            serviceDetails: "Custom art commission request"
                        }}
                        onClick={onContactClick}
                        className="mx-auto"
                    />
                </div>
            </div>
        </div>
    );
};

export default ArtGallery;